import { render, staticRenderFns } from "./DownloadApi.vue?vue&type=template&id=1fc44ec0"
import script from "./DownloadApi.vue?vue&type=script&lang=js"
export * from "./DownloadApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports